import { Button } from 'blaze-ui/Button'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { ImageNodeAttrs } from 'common/Prose/nodeViews/Image/Types'
import { Sun2 } from 'blaze-ui/icons'
import {
  CloudinaryEffectItem,
  CloudinaryEffectMenu,
} from 'common/Prose/nodeViews/Image/components/FormatBar/CloudinaryEffectMenu/CloudinaryEffectMenu'

interface Props {
  attrs: ImageNodeAttrs
  onAdjust: () => void
}

export const LightMenu = ({ attrs, onAdjust }: Props) => {
  return (
    <MenuTrigger>
      <Button frontIcon={Sun2} variant="tertiary" rounded size="xs" aria-label="Light">
        Light
      </Button>
      <CloudinaryEffectMenu aria-label="Light" onEffect={onAdjust} attrs={attrs}>
        <CloudinaryEffectItem key="brightness:0">Brightness</CloudinaryEffectItem>
        <CloudinaryEffectItem key="contrast:0">Contrast</CloudinaryEffectItem>
      </CloudinaryEffectMenu>
    </MenuTrigger>
  )
}
